export default __webpack_public_path__ + "static/media/logo-child3.92134624.svg";